import { api } from "@/api"
import type { User } from "./types"

export const sendUserLoginLink = async (
  userId: User["id"]
) => await api.post(`/users/${userId}/send-login-link/`)
